module.exports = __webpack_public_path__ + "static/zp-thin-ea88a6c0ca929958a8b76d90187baa4b.otf";